import { Fragment } from "react";
import { ResultOf } from "gql.tada";
import { TagFragment } from "@queries/fragments/TagFragment";

type Tag = ResultOf<typeof TagFragment>;

export const BlogTags = ({
  tags
}:{
  tags: Tag[]
}) => {

  return (
    <>
      {tags &&
        <>
          {tags.map((tag: Tag, index: number) => (
            <Fragment key={tag.slug}>
              {index > 0 && ', '}
              <span className="underline">{tag.tagLabel}</span>
            </Fragment>
          ))}
        </>
      }
    </>
  );
};
